import { Component, EventEmitter, HostListener, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ReducedScheduleTask } from 'src/app/models/scheduleTask.model';
import { ClientService } from 'src/app/services/client.services';
import { UserService } from 'src/app/shared/services/user.service';
import { taskStatuses } from 'src/assets/data/task-statuses';
import { thirdPartyApp } from 'src/assets/data/third-party-app';
import { NgClass, DatePipe } from '@angular/common';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-schedule-tasks-list',
    templateUrl: './schedule-tasks-list.component.html',
    styleUrls: ['./schedule-tasks-list.component.scss'],
    imports: [MatAccordion, MatExpansionPanel, NgClass, MatExpansionPanelHeader, MatButton, MatIconButton, MatDialogClose, MatIcon, DatePipe]
})
export class AppScheduleTasksListComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly clientSvc = inject(ClientService);
  usrSvc = inject(UserService);

  @Input() data: any = {};
  @Input() events: any = [];
  @Input() eventData: any = [];
  taskStatuses: any[] = taskStatuses;
  selectedId: string = '';
  @Output() OpenModalEvent = new EventEmitter<any>();
  thirdPartyAppList = thirdPartyApp;
  showContactModal: boolean = false;

  ngOnInit(): void {
    this.data = this.eventData ? this.eventData.event : undefined;
    this.events =
      this.eventData.length > 0 ? this.eventData.event.events : this.events;
  }

  getStatusColor(status: any) {
    return this.taskStatuses.find((x) => x.value == status).eventColor
      .secondary;
  }

  getStatusSelectedColor(status: any) {
    return this.taskStatuses.find((x) => x.value == status).eventColor.primary;
  }

  getStatusDescription(status: any) {
    return this.taskStatuses.find((x) => x.value == status).name;
  }

  expandDetail(id: string) {
    this.selectedId = this.selectedId == id ? '' : id;
  }

  dialogAction(event: any): void {
    this.OpenModalEvent.emit(event);
  }

  getThirdPartyAppName(fromThirdPartyApp: number) {
    let thirdPartyAppName: any;
    thirdPartyAppName = this.thirdPartyAppList.find(
      (x) => x.id == fromThirdPartyApp
    )?.name;

    return thirdPartyAppName || '';
  }

  onOrderChange(event: any) {
    const value = event.target.value;
    if (value === 'recent') {
      this.orderTasksRecent();
    } else {
      this.orderTasksOlder();
    }
  }

  orderTasksOlder() {
    type eventType = string | number | Date;
    this.events.sort(
      (
        a: { event: { data: { schudeledDate: eventType } } },
        b: { event: { data: { schudeledDate: eventType } } }
      ) =>
        new Date(a.event.data.schudeledDate).getTime() -
        new Date(b.event.data.schudeledDate).getTime()
    );
  }

  orderTasksRecent() {
    this.events.sort(
      (
        a: { event: { data: { schudeledDate: string | number | Date } } },
        b: { event: { data: { schudeledDate: string | number | Date } } }
      ) =>
        new Date(b.event.data.schudeledDate).getTime() -
        new Date(a.event.data.schudeledDate).getTime()
    );
  }

  openContactModal(contact?: any) {
    this.showContactModal = true;
  }

  applyPendingContactStyle(task: ReducedScheduleTask): boolean {
    if (this.usrSvc.hasPermission('view:pendingContactFilter')) {
      return !task.hasClientContact;
    }
    return false;
  }

  @HostListener('window:keydown.escape', ['$event'])
  backToScore(event?: KeyboardEvent) {
    this.showContactModal = false;
  }
}
